import React, { useState, useEffect } from 'react'
import { default as turfPolygon } from '@turf/area'
import { default as turfLine } from '@turf/length'
import { polygon } from '@turf/helpers'
import { lineString } from '@turf/helpers'
import { ViewMode } from '@nebula.gl/edit-modes'

import { makeStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'
import TextField from '@material-ui/core/TextField'
import IconButton from '@material-ui/core/IconButton'

import CloseIcon from '@material-ui/icons/Close'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'

import Convert from './CoordinateSystem/UtmFormulas'
import LayersApi from '../../Map/layers/LayersApi.js'

import './drawingTools.css'

const useStyles = makeStyles((theme) => ({
  coordinateInput: {
    '& .MuiOutlinedInput-root': {
      minWidth: 110,
      height: 30,
    },
    '& .MuiOutlinedInput-input': {
      padding: '18.5px 5px',
      fontSize: '12px !important',
    },
  },
  zoneInput: {
    '& .MuiOutlinedInput-root': {
      width: 40,
      height: 30,
    },
    '& .MuiOutlinedInput-input': {
      padding: '18.5px 5px',
      fontSize: '12px !important',
      textAlign: 'center',
    },
  },
  UtmInput: {
    '& .MuiOutlinedInput-root': {
      minWidth: 87,
      height: 30,
    },
    '& .MuiOutlinedInput-input': {
      padding: '18.5px 5px',
      fontSize: '12px !important',
    },
  },
}))

function EditMenu(props) {
  const [lbl, setLbl] = useState('')
  const [units, setUnits] = useState('km2')
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [values, setValues] = useState([])
  const [inputFlag, setInputFlag] = useState(false)
  const [index, setIndex] = useState(0)
  const [validation, setValidation] = useState(false)

  const classes = useStyles()

  useEffect(() => {
    // setValues(props.clickInfo.coordinates)
    props.clickInfo.type === 'LineString'
      ? setLbl(turfLine(lineString(props.clickInfo.coordinates), { units: 'kilometers' }).toFixed(2) + ' km')
      : props.clickInfo.type === 'Polygon'
      ? setLbl(turfPolygon(polygon([props.clickInfo.coordinates])).toFixed(2))
      : setLbl('')
    props.CRSID === 'DD'
      ? setValues(props.clickInfo.coordinates.map((val) => (val = { lat: val[1].toString(), lon: val[0].toString() })))
      : props.CRSID === 'DMS'
      ? setValues(props.clickInfo.coordinates.map((val) => (val = { lat: formatDMS(val[1]), lon: formatDMS(val[0]) })))
      : props.CRSID === 'UTM'
      ? setValues(props.clickInfo.coordinates.map((val) => toUTM(val[1], val[0])))
      : null
    name.trim() === '' ? setName(props.clickInfo.name) : updateTags()
    description.trim() === '' ? setDescription(props.clickInfo.description) : updateTags()

    // console.log(props.features.features)
    props.features.features.map((geom, i) => {
      geom === props.selectedGeometry ? setIndex(i) : null
    })
  }, [props.clickInfo, props.CRSID])

  useEffect(() => {
    if (props.editClick.visibility === 'hidden') {
      setName('')
      setDescription('')
    }
  }, [props.editClick])

  useEffect(() => {
    if (props.editClick.visibility === 'visible') {
      updateValues()
    }
  }, [props.layerHelper])

  useEffect(() => {
    if (props.editClick.visibility === 'visible') updateValues()
  }, [inputFlag])

  const changeName = (event) => {
    const { value } = event.target
    setName(value)
  }

  const changeDescription = (event) => {
    const { value } = event.target
    setDescription(value)
  }

  const changeValues = (event, i, key) => {
    const { value } = event.target
    setValues(
      values.map((obj) => {
        if (obj === values[i]) {
          // return {...obj, [key]:value.trim() === '' ? '0' :value};
          return { ...obj, [key]: value }
        }
        return obj
      }),
    )
  }

  const changeHem = (hem, i, key) => {
    setValues(
      values.map((obj) => {
        if (obj === values[i]) {
          // return {...obj, [key]:value.trim() === '' ? '0' :value};
          return { ...obj, [key]: hem }
        }
        return obj
      }),
    )
  }

  const setPoint = (position, bool) => {
    const info =
      props.CRSID === 'DD'
        ? { coordinates: [parseFloat(position[0]), parseFloat(position[1])] }
        : { coordinates: [convert(position[0]), convert(position[1])] }
    // console.log()
    const data = [
      {
        id: 'preview',
        geotype: 'geocreator-point',
        data: [info],
        design: {
          color: [0, 255, 0],
          radius: 8,
        },
        visible: bool,
        pickable: false,
      },
    ]
    bool ? props.setLayerHelper(LayersApi(data)) : props.setLayerHelper([])
  }

  const setPointUtm = (east, north, zone, hem, bool) => {
    const info = { coordinates: toLatLon(east, north, zone, hem) }
    const data = [
      {
        id: 'preview',
        geotype: 'geocreator-point',
        data: [info],
        design: {
          color: [0, 255, 0],
          radius: 8,
        },
        visible: bool,
        pickable: false,
      },
    ]

    bool ? props.setLayerHelper(LayersApi(data)) : props.setLayerHelper([])
  }

  const saveValues = () => {
    if (!validateValues(values)) {
      props.setMode(() => ViewMode)
      let formated = values.map((data) => {
        let coordinates = []
        props.CRSID === 'DD'
          ? (coordinates = [parseFloat(data.lon), parseFloat(data.lat)])
          : props.CRSID === 'DMS'
          ? (coordinates = [convert(data.lon), convert(data.lat)])
          : props.CRSID === 'UTM'
          ? (coordinates = toLatLon(data.east, data.north, data.zone.slice(0, -1), data.hem))
          : null
        return coordinates
      })
      props.clickInfo.type === 'Polygon'
        ? (formated = [formated])
        : props.clickInfo.type === 'LineString'
        ? (formated = formated)
        : (formated = formated[0])

      const update = props.features
      update.features[index].properties.name = name
      update.features[index].properties.description = description
      update.features[index].geometry.coordinates = formated

      props.setFeatures({
        type: 'FeatureCollection',
        features: update.features,
      })
      props.setToggler({ visibility: 'hidden', x: -100, y: -100 })
      props.setSelectedGeometry()
      setName('')
      setDescription('')
    } else {
      setValidation(true)
      setTimeout(() => setValidation(false), 2000)
    }
  }

  const updateValues = () => {
    if (!updateValidateValues(values)) {
      let formated = values.map((data) => {
        let coordinates = []
        props.CRSID === 'DD'
          ? (coordinates = [parseFloat(data.lon), parseFloat(data.lat)])
          : props.CRSID === 'DMS'
          ? (coordinates = [convert(data.lon), convert(data.lat)])
          : props.CRSID === 'UTM'
          ? (coordinates = toLatLon(data.east, data.north, data.zone.slice(0, -1), data.hem))
          : null
        return coordinates
      })
      if (props.clickInfo.type === 'Polygon') {
        formated[formated.length - 1] = formated[0]
        formated = [formated]
      }
      if (props.clickInfo.type === 'LineString') formated = formated
      if (props.clickInfo.type === 'Point') formated = formated[0]

      const update = props.features
      update.features[index].properties.name = name
      update.features[index].properties.description = description
      update.features[index].geometry.coordinates = formated

      props.setFeatures({
        type: 'FeatureCollection',
        features: update.features,
      })
    } else {
      setValidation(true)
      setTimeout(() => setValidation(false), 2000)
    }
  }

  const updateTags = () => {
    setName(props.clickInfo.name)
    setDescription(props.clickInfo.description)
  }

  const validateValues = (coordinates) => {
    let bool = false
    if (props.CRSID !== 'UTM') {
      coordinates.map((data) => {
        // data.lat.trim() === '' || data.lat.trim() === '' ? null : bool=true
        parseFloat(data.lon) > -180 && parseFloat(data.lon) < 180 ? null : (bool = true)
        parseFloat(data.lat) > -90 && parseFloat(data.lat) < 90 ? null : (bool = true)
      })
      coordinates[0].lat === coordinates[coordinates.length - 1].lat &&
      coordinates[0].lon === coordinates[coordinates.length - 1].lon
        ? null
        : (bool = props.clickInfo.type === 'Polygon' ? true : false)
      props.clickInfo.type === 'Polygon' && coordinates.length <= 3 ? (bool = true) : null
    } else if (props.CRSID === 'UTM') {
      coordinates.map((data) => {
        parseFloat(data.zone.slice(0, -1)) > 0 && parseFloat(data.zone.slice(0, -1)) <= 60 ? null : (bool = true)
        parseFloat(data.east.slice(0, -1)) > 0 ? null : (bool = true)
        parseFloat(data.north.slice(0, -1)) > 0 ? null : (bool = true)
      })
      coordinates[0].zone === coordinates[coordinates.length - 1].zone &&
      coordinates[0].east === coordinates[coordinates.length - 1].east &&
      coordinates[0].north === coordinates[coordinates.length - 1].north &&
      coordinates[0].hem === coordinates[coordinates.length - 1].hem
        ? null
        : (bool = props.clickInfo.type === 'Polygon' ? true : false)
      props.clickInfo.type === 'Polygon' && coordinates.length <= 3 ? (bool = true) : null
    }
    return bool
  }

  const updateValidateValues = (coordinates) => {
    let bool = false
    if (props.CRSID !== 'UTM') {
      coordinates.map((data) => {
        parseFloat(data.lon) > -180 && parseFloat(data.lon) < 180 ? null : (bool = true)
        parseFloat(data.lat) > -90 && parseFloat(data.lat) < 90 ? null : (bool = true)
      })
      props.clickInfo.type === 'Polygon' && coordinates.length <= 3 ? (bool = true) : null
    } else if (props.CRSID === 'UTM') {
      coordinates.map((data) => {
        parseFloat(data.zone.slice(0, -1)) > 0 && parseFloat(data.zone.slice(0, -1)) <= 60 ? null : (bool = true)
        parseFloat(data.east.slice(0, -1)) > 0 ? null : (bool = true)
        parseFloat(data.north.slice(0, -1)) > 0 ? null : (bool = true)
      })
      props.clickInfo.type === 'Polygon' && coordinates.length <= 3 ? (bool = true) : null
    }
    return bool
  }

  const addInput = () => {
    if (props.CRSID === 'DD') {
      const test = values
      test.push(values[values.length - 1])

      props.clickInfo.type === 'Polygon'
        ? setValues(
            test.map((obj, i) => {
              if (values.length - 2 === i) {
                return { lat: '', lon: '' }
              }
              return obj
            }),
          )
        : setValues((prevState) => {
            return [...prevState, { lat: '', lon: '' }]
          })
    } else {
      const test = values
      test.push(values[values.length - 1])

      props.clickInfo.type === 'Polygon'
        ? setValues(
            test.map((obj, i) => {
              if (values.length - 2 === i) {
                // return { lat: `0° 0' 0"`, lon: `0° 0' 0"`}
                return { lat: '', lon: '' }
              }
              return obj
            }),
          )
        : setValues((prevState) => {
            return [...prevState, { lat: '', lon: '' }]
          })
    }
  }

  const addInputUtm = () => {
    const test = values
    test.push(values[values.length - 1])

    props.clickInfo.type === 'Polygon'
      ? setValues(
          test.map((obj, i) => {
            if (values.length - 2 === i) {
              return {
                east: '',
                north: '',
                zone: '',
                hem: values[0].hem,
              }
            }
            return obj
          }),
        )
      : setValues((prevState) => {
          return [
            ...prevState,
            {
              east: '',
              north: '',
              zone: '',
              hem: values[0].hem,
            },
          ]
        })
  }

  const removeInput = (index) => {
    setValues(values.filter((d) => d !== values[index]))
    setInputFlag(inputFlag ? false : true)
  }

  const formatDMS = (value) => {
    const deg = Math.trunc(value)
    const min = parseFloat('0.' + value.toString().split('.')[1]) * 60
    const seg = parseFloat('0.' + min.toString().split('.')[1]) * 60

    // const reg=deg+(Math.trunc(min)/60)+(seg/3600)

    return `${deg + '° ' + Math.trunc(min) + "' " + seg + '"'}`
  }

  const convert = (value) => {
    const coords = value.split(' ').map((val, i) => {
      return parseFloat(val.replace(/[°'"]/g, ''))
    })
    const replace =
      coords[0] > 0 ? coords[0] + coords[1] / 60 + coords[2] / 3600 : coords[0] - coords[1] / 60 - coords[2] / 3600

    return replace
  }

  const toUTM = (lat, lon) => {
    var xy = new Array(2)
    var zone = Math.floor((lon + 180.0) / 6) + 1
    Convert.LatLonToUTMXY(Convert.DegToRad(lat), Convert.DegToRad(lon), zone, xy)
    const em = lat < 0 ? true : false
    let utmBand = Convert.UTMBand(Math.trunc(lat))
    return {
      east: xy[0].toString(),
      north: xy[1].toString(),
      zone: zone.toString() + utmBand,
      hem: em,
    }
  }

  const toLatLon = (east, north, zone, hem) => {
    let latlon = new Array(2)

    Convert.UTMXYToLatLon(east, north, zone, hem, latlon)
    const coordinates = [Convert.RadToDeg(latlon[1]), Convert.RadToDeg(latlon[0])]
    return coordinates
  }

  const addBtn = (
    <IconButton
      size="small"
      component="span"
      onClick={(event) => {
        props.CRSID === 'UTM' ? addInputUtm() : addInput()
      }}
      style={{ position: 'absolute', right: '0px', height: '20px', width: '20px' }}
    >
      <AddIcon style={{ height: '20px', width: '20px' }} />
    </IconButton>
  )

  const latLon = (
    <div style={{ display: 'flex', gap: '5px' }}>
      <div style={{ display: 'flex', flexFlow: 'column', gap: '5px' }}>
        <label style={{ margin: 'auto' }}>Latitude</label>
        {values.map((data, index) =>
          props.clickInfo.type === 'Polygon' && index === values.length - 1 ? null : (
            <TextField
              className={classes.coordinateInput}
              id="outlined-basic"
              size="small"
              variant="outlined"
              value={data.lat}
              onChange={(evt) => {
                changeValues(evt, index, 'lat')
                setPoint([data.lon, evt.target.value], true)
              }}
              onFocus={() => setPoint([data.lon, data.lat], true)}
              onBlur={() => setPoint([data.lon, data.lat], false)}
              style={
                parseFloat(data.lat) > -90 && parseFloat(data.lat) < 90
                  ? null
                  : { background: '#ffdada', color: '#bd0000', borderRadius: '4px' }
              }
            />
          ),
        )}
      </div>
      <div style={{ display: 'flex', flexFlow: 'column', gap: '5px' }}>
        <label style={{ margin: 'auto' }}>Longitude</label>
        {values.map((data, index) =>
          props.clickInfo.type === 'Polygon' && index === values.length - 1 ? null : (
            <div style={{ display: 'flex', gap: '2px' }}>
              <TextField
                className={classes.coordinateInput}
                id="outlined-basic"
                size="small"
                variant="outlined"
                value={data.lon}
                onChange={(evt) => {
                  changeValues(evt, index, 'lon')
                  setPoint([evt.target.value, data.lat], true)
                }}
                onFocus={() => setPoint([data.lon, data.lat], true)}
                onBlur={() => setPoint([data.lon, data.lat], false)}
                style={
                  parseFloat(data.lon) > -180 && parseFloat(data.lon) < 180
                    ? null
                    : { background: '#ffdada', color: '#bd0000', borderRadius: '4px' }
                }
              />
              {props.clickInfo.type !== 'Point' ? (
                <IconButton
                  size="small"
                  component="span"
                  onClick={(event) => removeInput(index)}
                  style={{ alignSelf: 'center', height: '20px', width: '20px' }}
                >
                  <RemoveIcon style={{ height: '20px', width: '20px' }} />
                </IconButton>
              ) : null}
            </div>
          ),
        )}
      </div>
    </div>
  )

  const utm = (
    <div style={{ display: 'flex', gap: '5px' }}>
      <div style={{ display: 'flex', flexFlow: 'column', gap: '5px' }}>
        <label style={{ margin: 'auto' }}>Zone</label>
        {values.map((data, index) =>
          props.clickInfo.type === 'Polygon' && index === values.length - 1 ? null : (
            <div style={{ display: 'flex' }}>
              <div className="dt-hem-btn">
                <div
                  className="dt-hem-container-north"
                  style={!data.hem ? { color: '#fff', background: '#03a9f4', pointerEvents: 'none' } : null}
                  onClick={() => {
                    changeHem(false, index, 'hem')
                    setPointUtm(data.east, data.north, data.zone.slice(0, -1), false, false)
                  }}
                >
                  <label className="dt-hem-btn-north">N</label>
                </div>
                <div
                  className="dt-hem-container-south"
                  style={data.hem ? { color: '#fff', background: '#03a9f4', pointerEvents: 'none' } : null}
                  onClick={() => {
                    changeHem(true, index, 'hem')
                    setPointUtm(data.east, data.north, data.zone.slice(0, -1), true, false)
                  }}
                >
                  <label className="dt-hem-btn-south">S</label>
                </div>
              </div>
              <TextField
                className={classes.zoneInput}
                id="outlined-basic"
                size="small"
                variant="outlined"
                value={data.zone}
                onChange={(evt) => {
                  changeValues(evt, index, 'zone')
                  setPointUtm(data.east, data.north, evt.target.value.slice(0, -1), data.hem, true)
                }}
                onFocus={() => setPointUtm(data.east, data.north, data.zone.slice(0, -1), data.hem, true)}
                onBlur={() => setPointUtm(0, 0, 31, false, false)}
                style={
                  data.zone && parseFloat(data.zone.slice(0, -1)) > 0 && parseFloat(data.zone.slice(0, -1)) <= 60
                    ? null
                    : { background: '#ffdada', color: '#bd0000', borderRadius: '4px' }
                }
              />
            </div>
          ),
        )}
      </div>
      <div style={{ display: 'flex', flexFlow: 'column', gap: '5px' }}>
        <label style={{ margin: 'auto' }}>East</label>
        {values.map((data, index) =>
          props.clickInfo.type === 'Polygon' && index === values.length - 1 ? null : (
            <TextField
              className={classes.UtmInput}
              id="outlined-basic"
              size="small"
              variant="outlined"
              value={data.east}
              onChange={(evt) => {
                changeValues(evt, index, 'east')
                setPointUtm(evt.target.value, data.north, data.zone.slice(0, -1), data.hem, true)
              }}
              onFocus={() => setPointUtm(data.east, data.north, data.zone.slice(0, -1), data.hem, true)}
              onBlur={() => setPointUtm(0, 0, 31, false, false)}
              style={
                parseFloat(data.east) > 0 ? null : { background: '#ffdada', color: '#bd0000', borderRadius: '4px' }
              }
            />
          ),
        )}
      </div>
      <div style={{ display: 'flex', flexFlow: 'column', gap: '5px' }}>
        <label style={{ margin: 'auto' }}>North</label>
        {values.map((data, index) =>
          props.clickInfo.type === 'Polygon' && index === values.length - 1 ? null : (
            <div style={{ display: 'flex', gap: '2px' }}>
              <TextField
                className={classes.UtmInput}
                id="outlined-basic"
                size="small"
                variant="outlined"
                value={data.north}
                onChange={(evt) => {
                  changeValues(evt, index, 'north')
                  setPointUtm(data.east, evt.target.value, data.zone.slice(0, -1), data.hem, true)
                }}
                onFocus={() => setPointUtm(data.east, data.north, data.zone.slice(0, -1), data.hem, true)}
                onBlur={() => setPointUtm(0, 0, 31, false, false)}
                style={
                  parseFloat(data.north) > 0 ? null : { background: '#ffdada', color: '#bd0000', borderRadius: '4px' }
                }
              />
              {props.clickInfo.type !== 'Point' ? (
                <IconButton
                  size="small"
                  component="span"
                  onClick={(event) => removeInput(index)}
                  style={{ alignSelf: 'center', height: '20px', width: '20px' }}
                >
                  <RemoveIcon style={{ height: '20px', width: '20px' }} />
                </IconButton>
              ) : null}
            </div>
          ),
        )}
      </div>
    </div>
  )

  return (
    <div>
      <div style={{ color: 'black', height: '20px', display: 'flex' }}>
        <label className="on-click-title">Edit Geometry</label>
        <CloseIcon
          style={{
            fontSize: '19px',
            position: 'relative',
            margin: 'auto',
            marginRight: '5px',
            cursor: 'pointer',
          }}
          onClick={() => {
            setName('')
            setDescription('')
            setValues([])
            props.setMode(() => ViewMode)
            props.close()
          }}
        />
      </div>
      <div className="info-container" style={{ padding: '10px' }}>
        <TextField
          id="filled-name"
          label="Name"
          size="small"
          style={{ width: '100%' }}
          variant="outlined"
          value={name}
          onChange={changeName}
          onBlur={() => updateValues()}
        />
        <TextField
          id="filled-description"
          label="Description"
          multiline
          rows={4}
          variant="outlined"
          style={{ width: '100%', marginTop: '10px' }}
          value={description}
          onChange={changeDescription}
          onBlur={() => updateValues()}
        />

        <div
          style={{
            background: '#2b2b2b26',
            display: 'grid',
            borderRadius: '4px',
            position: 'relative',
            marginTop: '10px',
          }}
        >
          {props.clickInfo.type === 'Polygon' ? (
            <label className="gm-coordinates-title">
              {props.units === 'km2'
                ? Intl.NumberFormat('en-US').format((lbl / 1) * Math.pow(10, -6)) + '  km2'
                : props.units === 'ha'
                ? Intl.NumberFormat('en-US').format(lbl / 10000) + '  ha'
                : Intl.NumberFormat('en-US').format(lbl) + '  m2'}
            </label>
          ) : (
            <label className="gm-coordinates-title">{lbl}</label>
          )}
          {props.clickInfo.type === 'Polygon' ? (
            props.units === 'km2' ? (
              <div className="dt-units-btn" onClick={() => props.setUnits('ha')}>
                {' '}
                ha{' '}
              </div>
            ) : props.units === 'ha' ? (
              <div className="dt-units-btn" onClick={() => props.setUnits('m2')}>
                {' '}
                m2{' '}
              </div>
            ) : (
              <div className="dt-units-btn" onClick={() => props.setUnits('km2')}>
                {' '}
                km2{' '}
              </div>
            )
          ) : null}
        </div>
        <div style={{ display: 'grid', position: 'relative' }}>
          <label className="gm-coordinates-title">Coordinates</label>
          {props.clickInfo.type === 'Polygon' || props.clickInfo.type === 'LineString' ? addBtn : null}
        </div>
        <div className="gm-coordinates-container">{props.CRSID !== 'UTM' ? latLon : utm}</div>
      </div>
      <div style={{ display: 'flex', marginBottom: '5px' }}>
        <button
          className="gm-info-btn"
          onClick={() => {
            saveValues()
          }}
          disabled={validation}
          style={validation ? { background: '#b0b0b0' } : null}
        >
          Save
        </button>
        <button
          className="gm-info-btn"
          onClick={() => {
            setName('')
            setDescription('')
            setValues([])
            props.setMode(() => ViewMode)
            props.close()
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  )
}

EditMenu.defaultProps = {
  name: '',
  description: '',
  type: '',
  coordinates: [[0, 0]],
}

export default EditMenu
